import React from 'react';
import {useTranslation} from 'react-i18next';
import {actualChargeLabel,displayGoldbase,formatUsdGoldbase,usesUsdDisplay} from './display-price';
import './config';

// These components only render text. They never update products or quote data.
export function PackagePrice({product,goldbase,children}){
 const {t,i18n}=useTranslation('translations');
 if(!usesUsdDisplay(i18n.language))return <>{children}</>;
 const base=goldbase===undefined?displayGoldbase(product):goldbase;
 return <span className="op-usd-display-price">{formatUsdGoldbase(base)||t('UI.priceUnavailable')}</span>;
}

export function ChinesePriceOnly({children}){
 const {i18n}=useTranslation('translations');
 return usesUsdDisplay(i18n.language)?null:<>{children}</>;
}

export function ActualCharge({amountMinor,currency}){
 const {t,i18n}=useTranslation('translations');
 if(!usesUsdDisplay(i18n.language))return null;
 const amount=actualChargeLabel(amountMinor,currency);
 return <small className="op-actual-charge" style={{display:'block',whiteSpace:'normal',lineHeight:1.5,marginTop:6}}>
  {amount?t('UI.actualCharge',{amount}):t('UI.actualChargeUnavailable')}
 </small>;
}
